import { useRef } from "react";
import ReactToPrint from "react-to-print";

export default function Sample() {
  const componentRef = useRef();
  return (
    <div>
      <ReactToPrint
        trigger={() => <button>Print this out!</button>}
        content={() => componentRef.current}
      />
      <div className="d-none" ref={componentRef}>
        ooooooooooooooooo
      </div>
    </div>
  );
}
